import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {
    NumberWidth, ReportContactCodeWidth,
    ReportContactWidth,
    ReportDateWidth,
    TypeWidth,
} from "../../../Table/Common/CommonWidths";
import {AmountTdWidth} from "../../../Table/Common/AmountTd";
import {
    Helper,
} from "../../../../containers/AppPage/Reports/ProductSalesAndPurchases/Common/DetailPage/helper";

function getColumns(props) {
    const { reportData } = props;

    const currencySymbol = reportData?.company?.currency_symbol;
    return [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 0,
            flexGrow: ReportDateWidth,
            cellRenderer: Helper.renderDate,
        },
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 0,
            flexGrow: NumberWidth,
            cellRenderer: Helper.renderNumber,
        },
        {
            title: t`Type`,
            dataIndex: 'type',
            key: 'type',
            width: 0,
            flexGrow: TypeWidth,
            cellRenderer: Helper.renderType,
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'contact_name',
            width: 0,
            flexGrow: ReportContactWidth,
            cellRenderer: Helper.renderContact,
        },
        {
            title: t`Contact Code`,
            dataIndex: 'contact_code',
            key: 'contact_code',
            width: 0,
            flexGrow: ReportContactCodeWidth,
            cellRenderer: Helper.renderContactCode,
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            width: 0,
            flexGrow: ReportContactWidth,
            cellRenderer: Helper.renderDescription,
        },
        {
            title: t`Quantity`,
            dataIndex: 'quantity',
            key: 'quantity',
            align: 'right',
            width: 0,
            flexGrow: 90,
            cellRenderer: Helper.renderQuantity,
        },
        {
            title: t`Unit Price`,
            dataIndex: 'unit_price',
            key: 'unit_price',
            align: 'right',
            width: 0,
            flexGrow: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.unit_price, currencySymbol),
        },
        {
            title: t`Amount`,
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            width: 0,
            flexGrow: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.amount, currencySymbol),
        },
        {
            title: t`Discount`,
            dataIndex: 'discount_amount',
            key: 'discount_amount',
            align: 'right',
            width: 0,
            flexGrow: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.discount_amount, currencySymbol),
        },
        {
            title: t`Tax`,
            dataIndex: 'tax_amount',
            key: 'tax_amount',
            align: 'right',
            width: 0,
            flexGrow: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.tax_amount, currencySymbol),
        },
        {
            title: t`Net Amount`,
            dataIndex: 'net_amount',
            key: 'net_amount',
            align: 'right',
            width: 0,
            flexGrow: AmountTdWidth,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.net_amount, currencySymbol),
        },
    ];
}

export default {
    storageKey: StorageKey.report_product_sales_detail,
    getReportLabel: () => t`Product Sales Detail`,
    required: [
        'date',
        'number',
        'net_amount',
    ],
    defaulto: [
        'description',
        'quantity',
        'unit_price',
    ],
    getColumns,
};
